import apiClient from "../apiInstance.js";
import { AGENTINFO_URLS } from "../apiConfig.js";
import { ACSIDENTITY_ERRORS } from "../../common/constants/ivrModule/acsConstants.js";

export const getAgentNotes = async ({agentguid}) => {
    try {
        const response = await apiClient.post(AGENTINFO_URLS.GET_AGENTINFO_NOTES, {
            agentguid
        });
        return response.data;
    } catch (error) {
        console.error(ACSIDENTITY_ERRORS.FETCH_ACSIDENTITY_ERROR, error);
        throw error;
    }
};

export const getAgentCalls = async ({agentguid}) => {
    try {
        const response = await apiClient.post(AGENTINFO_URLS.GET_AGENTINFO_CALLS, {
            agentguid
        });
        return response.data;
    } catch (error) {
        console.error(ACSIDENTITY_ERRORS.FETCH_ACSIDENTITY_ERROR, error);
        throw error;
    }
};

export const getAgentChats = async ({agentGUID}) => {
    try {
        const response = await apiClient.post(AGENTINFO_URLS.GET_AGENTINFO_CHATS, {
            agentGUID
        });
        return response.data;
    } catch (error) {
        console.error(ACSIDENTITY_ERRORS.FETCH_ACSIDENTITY_ERROR, error);
        throw error;
    }
};

export const getAgentTexts = async ({agentGUID}) => {
    try {
        const response = await apiClient.post(AGENTINFO_URLS.GET_AGENTINFO_TEXTS, {
            agentGUID
        });
        return response.data;
    } catch (error) {
        console.error(ACSIDENTITY_ERRORS.FETCH_ACSIDENTITY_ERROR, error);
        throw error;
    }
};

export const getAgentEmails = async ({agentguid}) => {
    try {
        const response = await apiClient.post(AGENTINFO_URLS.GET_AGENTINFO_EMAILS, {
            agentguid
        });
        return response.data;
    } catch (error) {
        console.error(ACSIDENTITY_ERRORS.FETCH_ACSIDENTITY_ERROR, error);
        throw error;
    }
};

export const getAgentPayments = async ({agentguid}) => {
    try {
        const response = await apiClient.post(AGENTINFO_URLS.GET_AGENTINFO_PAYMENTS, {
            agentguid
        });
        return response.data;
    } catch (error) {
        console.error(ACSIDENTITY_ERRORS.FETCH_ACSIDENTITY_ERROR, error);
        throw error;
    }
};